// extracted by mini-css-extract-plugin
export default {"tableWrapper":"styles_tableWrapper__snB51","loadingContainer":"styles_loadingContainer__KdiJx"};